import { Avatar, Col, Row, Text } from 'ui';
import { images } from 'common/utils';

type P = {
  description?: string;
  image?: {
    alt: string;
    src?: string;
  };
  title: string;
};

const OrganizationOption = ({ description, image, title }: P) => (
  <Row align="middle" gutter={['ms', 0]}>
    {image ? (
      <Col>
        <Avatar alt={image.alt} fallbackPhoto={images.default.organizationProfilePhoto} size="lg" src={image.src} />
      </Col>
    ) : null}
    <Col flex="1 1 0">
      <Row>
        <Col span={24}>
          <Text>{title}</Text>
        </Col>
        {description ? (
          <Col span={24}>
            <Text type="secondary">{description}</Text>
          </Col>
        ) : null}
      </Row>
    </Col>
  </Row>
);

export default OrganizationOption;
